import { getExchangeServerVersionInfo } from 'owa-session-store/lib/services/sessionDataResponseStash';

export default function isSortingPersisted(): Boolean {
    const exchangeVersion = getExchangeServerVersionInfo();
    // Remove the version check after 15.20.1807 is deployed WW
    // This is needed to match what server sorts when sending SessionData responses
    if (
        exchangeVersion &&
        (exchangeVersion.MajorVersion > 15 ||
            exchangeVersion.MinorVersion > 20 ||
            exchangeVersion.MajorBuildNumber >= 1807)
    ) {
        return true;
    }

    return false;
}
